export default "__VITE_ASSET__79603372__"